import classes from '@/App.module.scss';
import ReportTable from '@/components/InferenceResults/InferenceResults';
import { ContentSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton';

import { Suspense } from 'react';

export default function PageInferenceResults() {
  return (
    <div className={classes.reportsPage}>
      <div className={classes.reportTable}>
        <Suspense
          fallback={<ContentSkeleton />}
        >
          <ReportTable />
        </Suspense>
      </div>
    </div>
  );
}
